import { render, staticRenderFns } from "./AccessForm.vue?vue&type=template&id=229a6e38&"
import script from "./AccessForm.vue?vue&type=script&lang=js&"
export * from "./AccessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports